import { Chip } from '@/components/commons/chip'
import { ImageCard } from '@/components/commons/image-card'
import { Image01Icon, Stars01Icon } from '@/components/ui/icons'
import type { PhotosetSpace } from '@/features/photoset/types'
import { useTranslation } from '@/translations/i18n'
import { SpaceImagesContainer } from '../space-images-atoms'

export const AiManualRetouchingSpaceImages = ({
	images,
	isLoadingManualRetouchingSpaces
}: {
	images: PhotosetSpace['images']
	isLoadingManualRetouchingSpaces: boolean
}) => {
	const { t } = useTranslation()

	return (
		<SpaceImagesContainer $gap={4}>
			{images.map((image) => {
				const thumbnails =
					image.retouched_thumbnails?.xs ||
					image.ai_retouched_thumbnails?.xs

				return (
					<ImageCard
						badgeType='selection'
						endSlot={
							!isLoadingManualRetouchingSpaces && (
								<>
									{image.is_manually_retouched && (
										<Chip
											isActive={true}
											label={t(
												'common:manually_retouched'
											)}
											variant={'info'}
										/>
									)}

									{image.need_manual_retouching &&
										!image.is_manually_retouched && (
											<Chip
												isActive={true}
												label={t(
													'photoset:ai_manual_retouching.not_retouched'
												)}
												variant={'danger'}
											/>
										)}
								</>
							)
						}
						hideCheckbox={true}
						image={image}
						imageNameIcon={
							image.is_manually_retouched ? (
								<Image01Icon size={20} />
							) : (
								<Stars01Icon size={20} />
							)
						}
						isLoading={false}
						isSelected={image.need_manual_retouching}
						key={image.id}
						loadingText={t('common:generating_thumbnails')}
						showBadge={!!image.retouched_thumbnails?.xs}
						thumbnail={thumbnails}
					/>
				)
			})}
		</SpaceImagesContainer>
	)
}
